module.exports = __webpack_public_path__ + "img/banner-princiapal.d88670fb.png";